export default {
  heading: {
    subtitle: "Débouchage à Toulouse",
    icons: [
      {
        src: "/img/icons/approve-invoic-bicolor-light.png",
        alt: "Icone devis",
      },
      {
        src: "/img/icons/calendar-bicolor-light.png",
        alt: "Icone calendrier",
      },
      {
        src: "/img/icons/piggy-bank-bicolor-light.png",
        alt: "Icone tarifs",
      },
    ],
    items: [
      " Tous types de canalisations",
      " Intervention dans la semaine",
      " Débouchage partir de 60 € TTC",
    ],
  },
  section1: {
    title: "Optez pour débouchage rapide :",
    text: `L'utilisation quotidienne peut progressivement créer des bouchons dans vos canalisations. Evier, baignoire, douche ou encore toilettes, toutes ces parties sont concernées.`,
    ctaText: "Pour un débouchage au plus vite, appelez-nous au :",
  },
  section2: {
    title: "",
    subtitle1: "",
    steps1: [
      "Inspecter les canalisations bouchées",
      "Utiliser une caméra d'inspection si besoin",
      "Choisir la solution la plus adaptée à votre installation (évier, baignoire, douche, wc...)",
      "Procéder au débouchage / curage",
      "Vous conseiller pour limiter les risques de récidives",
    ],
    text1: "",
    subtitle2: "",
    text2:
      "Selon l’accessibilité des canalisations, un débouchage peut durer entre 30 minutes et 4h.",
    subtitle3: "",
    text3:
      "Le prix d'un débouchage dépend principalement de l'accessibilité du bouchon et donc des outils nécessaires . Notre professionnel du débouchage choisira la solution la plus adaptée au problème et à votre installation. Pour une heure de main d'oeuvre :",
    steps3: [
      "Le bouchon est léger, une pompe manuelle et une inspection approfondie du siphon peuvent suffire : 60 € TTC ",
      "L'utilisation de produits chimiques professionnels (non disponibles en grande surface). Attention, ne convient pas à toutes les installations : 85 € TTC",
      "L'emploi d'un furet mécanique pour les canalisations plus difficiles d'accès : 85 € TTC",
      "Hydrocurage haute-pression : sous devis, selon votre installation de canalisations",
    ],
    lastText: "",
    ctaText: "Planifiez votre débouchage dans la semaine ! <br />",
    ctaTextMobile:
      'Appelez-nous et planifiez <br />votre débouchage dans <span class="no-wrap"> la semaine !</span>',
  },
  aside: {
    ctaText: "Une canalisation ou un évier bouché ? Appelez-nous : ",
    img: {
      src: "/img/pages/mix-cumulus.jpg",
      alt: "Changement de cumulus",
    },
    quoteRequest: {
      recipient: "contact+devisDebouchage",
      body:
        "Bonjour,%0D%0A %0D%0A voici ma demande de devis de débouchage :%0D%0A - Description : %0D%0A - Délai : %0D%0A - Code postal : %0D%0A - Ville : %0D%0A - Nom : %0D%0A - Numéro de téléphone (optionnel) : %0D%0A %0D%0A Bien à vous",
    },
  },
};
